var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"data-value"},[_c('span',{staticClass:"data-value-label body-1 font-weight-bold"},[_vm._v(" "+_vm._s(_vm.label)+" ")]),_c('span',{staticClass:"data-value-value body-1 text-right"},[_vm._v(" "+_vm._s(_vm.value)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }